<template>
    <div class="vue-tempalte">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <form ref="serviceForm" @submit.prevent="onFormSubmit">
                        <h3>Добави полезен съвет</h3>

                        <div class="form-group">
                            <label>Снимка</label>
                            <input type="file" class="form-control form-control-lg"  ref="file" v-on:change="handleFileUpload()" required>
                        </div>
                        <div class="form-group">
                            <label>Заглавие</label>
                            <input type="text" class="form-control form-control-lg" v-model="tips.name" required>
                        </div>

                        <div class="form-group">
                            <label>Описание</label>
                            <div class="editor-wrapper">
                                <vue-editor v-model="tips.description"  required></vue-editor>
                            </div>
                        </div>

                        <div class="form-group">
                            <button :disabled="!tips.description" class="btn btn-primary btn-block">Запази</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                tips: {
                    name: '',
                    description: '',
                    image: '',
                    createdAt: Date.now()
                }
            }
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault();
                db.collection('tips').add(this.tips).then(() => {
                    alert("Успешно добавен случай!");
                    this.tips.name = null;
                    this.tips.description = null;
                    this.$refs.file.files[0] = null;
                }).catch((error) => {
                    console.log(error);
                });
            },

            handleFileUpload(){
                const reader = new FileReader();
                reader.readAsDataURL(this.$refs.file.files[0]);
                reader.onload = ()=> {
                    this.tips.image = reader.result;
                };
            }
        }
    }
</script>
